import { render, staticRenderFns } from "./IpFilters.vue?vue&type=template&id=0704e4de&scoped=true"
import script from "./IpFilters.vue?vue&type=script&lang=js"
export * from "./IpFilters.vue?vue&type=script&lang=js"
import style0 from "./IpFilters.vue?vue&type=style&index=0&id=0704e4de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704e4de",
  null
  
)

export default component.exports